import React, { forwardRef } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const Imaging = forwardRef<SVGSVGElement, SvgIconProps>(
  function Imaging(props, ref) {
    return (
      <SvgIcon ref={ref} {...props}>
        <path d="M18.667 15.321c0-.327.487-.374.814-.374.157 0 .52.062.632.173.11.111.22.044.22.201v4.36c0 .158-.11.309-.22.42-.111.11-.273.22-.43.22H4.306c-.157 0-.308-.11-.419-.22-.11-.111-.22-.262-.22-.42v-4.36c0-.327.312-.374.639-.374s1.027.047 1.027.374v3.333h13.334v-3.333zM4.5 16.154a.833.833 0 110-1.666.833.833 0 010 1.666zm15 0a.833.833 0 110-1.666.833.833 0 010 1.666zM9.04 15.54a.592.592 0 01-.591-.592V9.028c0-.327.265-.591.592-.591h5.918a.592.592 0 01.592.591v5.919a.592.592 0 01-.592.592H9.041zM3.668 8.655V4.293c0-.157.11-.308.22-.42.111-.11.262-.22.419-.22h15.377c.157 0 .319.11.43.22.11.112.22.263.22.42v4.36c0 .157-.11.09-.22.201-.111.111-.475.173-.632.173-.327 0-.814-.047-.814-.374V5.321H5.333v3.333a.833.833 0 01-1.666 0zM19.5 7.82a.833.833 0 110 1.667.833.833 0 010-1.667z" />
      </SvgIcon>
    )
  },
)

export default Imaging
